import { ElementType } from 'react';
import Headline from './Headline';

/** Типы заголовка */
type HeadlineTypes = 'xxsmall' | 'xsmall' | 'small' | 'default' | 'large' | 'xlarge';
/** Основные цвета заголовка */
type HeadlineColors = 'std' | 'gray' | 'grayDark' | 'error';
/** Тип описывающий заголовок */
type HeadlineOptionType = {
	/** Элемент */
	tag: ElementType;
	/** Наименование класса */
	className: string;
};

/** Объект с типами заголовка и их характеристики */
export const HeadlineOptions: Record<string,HeadlineOptionType> = {
	xxsmall: {
		tag: 'h6',
		className: 'headline-xxsmall'
	},
	xsmall: {
		tag: 'h5',
		className: 'headline-xsmall'
	},
	small: {
		tag: 'h4',
		className: 'headline-small'
	},
	default: {
		tag: 'h3',
		className: 'headline'
	},
	large: {
		tag: 'h2',
		className: 'headline-large'
	},
	xlarge: {
		tag: 'h1',
		className: 'headline-xlarge'
	}
};

export type { HeadlineTypes, HeadlineColors };
export default Headline;
